<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>edit</mat-icon> Edit Housing Unit Association OHA Id: {{housingUnitId}}
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='loading'>Close</button>
  </div>
</div>

<mat-dialog-content>
  <div *ngIf="!loading">
    <form [formGroup]="housingUnitForm">
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card fxFlex="100">
            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex.lt-sm="50">
                <mat-form-field appearance="standard">
                  <mat-label>Start Date</mat-label>
                  <input id="housingUnitStartDate" name="housingUnitStartDate" formControlName="housingUnitStartDate"
                    placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerHousingUnitStartDate" />
                  <mat-datepicker-toggle matSuffix [for]="datepickerHousingUnitStartDate"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerHousingUnitStartDate>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex.lt-sm="50">
                <mat-form-field appearance="standard">
                  <mat-label>End Date</mat-label>
                  <input id="housingUnitEndDate" name="housingUnitEndDate" formControlName="housingUnitEndDate" placeholder="mm/dd/yyyy"
                    matInput [matDatepicker]="datepickerHousingUnitEndDate" />
                  <mat-datepicker-toggle matSuffix [for]="datepickerHousingUnitEndDate"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerHousingUnitEndDate>
                    <mat-datepicker-actions>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                      <button mat-button matDatepickerCancel>Cancel</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row" *ngIf="!loading">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <!-- (click)="associateWell()" -->
          <button type="submit" id="submitButtonSearch" mat-raised-button color="primary"
            title="Update Housing Unit Association" [disabled]='loading' (click)="updateHousingUnitAssociation()">Update
            Housing Unit Association</button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>